<template>
  <div>
    <DatePicker
      :dateValue="startDate"
      :labelText="startDateLabel"
      :clear="clear"
      @changeDate="changeRangeDate($event, 'startDate')"
      :allowedDatesFunction="allowedDateStart"
      :dense="dense"
    />
    <DatePicker
      :dateValue="endDate"
      :labelText="endDateLabel"
      :clear="clear"
      @changeDate="changeRangeDate($event, 'endDate')"
      :allowedDatesFunction="allowedDateEnd"
      :dense="dense"
    />
  </div>
</template>

<script>
import { DatePicker } from '@/components/common'
export default {
  name: 'RangeDatePicker',
  components: {
    DatePicker
  },
  props: {
    startDate: {
      type: String,
      default: ''
    },
    startDateLabel: {
      type: String,
      default: 'Дата c:'
    },
    endDate: {
      type: String,
      default: ''
    },
    endDateLabel: {
      type: String,
      default: 'Дата по:'
    },
    allowDatesPeriod: {
      type: Number,
      default: 0
    },
    allowLastPickDate: {
      type: String,
      default: ''
    },
    dense: {
      type: Boolean,
      default: false
    },
    clear: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    changeRangeDate(value, name) {
      this.$emit(`update:${name}`, value)
      this.$emit('changeRange', { name, value })
    },
    allowedDateStart(val) {
      if (this.endDate !== null) {
        return val <= this.endDate
      } else return val
    },
    allowedDateEnd(val) {
      if (this.startDate !== null) {
        if (this.allowLastPickDate) {
          return val >= this.startDate && val <= this.allowLastPickDate
        }
        return val >= this.startDate
      } else return val
    }
  }
}
</script>

